/**
 * Parse a French price string to a number.
 * Handles formats like "28.50 €/m²", "4 275 €", "2 500 €/ff", "28,50"
 */
export const parsePrixString = (str: string): number => {
  const cleanPrice = str.replace(/[^\d,.]/g, '');
  const normalizedPrice = cleanPrice.replace(',', '.');
  const prix = parseFloat(normalizedPrice);
  return isNaN(prix) ? 0 : prix;
};

/**
 * Format a number as a French price string: 28.5 → "28,50"
 */
export const formatPrix = (n: number): string => {
  return n.toLocaleString('fr-FR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};
